import React, { useEffect, useState } from "react";
import axiosClient from "../../front/axiosClient";
import { Icons } from "../../front/components/Icons";
import { Link } from "react-router-dom";
import BackButton from "../../front/components/BackButton";
import empty from "../../images/empty.png";
import Popup from "../../components/Popup";
const BarbersInShop = () => {
	const [barbers, setBarbers] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");
    const [alert, setAlert] = useState(null);

	useEffect(() => {
		const fetchBarbers = async () => {
			try {
				const response = await axiosClient.get(`/barber/shop-barbers.php`);
				setBarbers(response.data.data);
			} catch (err) {
				setError("Whoops, something went wrong!");
			} finally {
				setLoading(false);
			}
		};

		fetchBarbers();
	}, []);

	const handleDelete = async (id) =>{
		try {
			const response = await axiosClient.delete(`/barber/shop-barbers.php`);
			setAlert({ type: "success", message: response.data.message });
		} catch (err) {
			setAlert({ type: "error", message: 'Whoops, something went wrong!' });
		} finally {
			setLoading(false);
		}
	}

	if (loading) return <p>Loading satff...</p>;
	if (error) return <p>{error}</p>;

	return (
		<div className="manage-section">
			 {alert && (
                <Popup type={alert.type} message={alert.message} />
            )}
			<div className='page-header'>
				<Link to="" style={{ fontSize: '20px', color: 'gray' }}><BackButton /></Link>
				<h4 style={{ fontSize: '16px', fontWeight: '600' }}>Manage Staff</h4>
			</div>
			{barbers && barbers.length > 0 ? (
				<div className="add-service row">
					<Link to="/add-staff" className="btn-primary">Add New</Link>
				</div>
			) : ("")}

			<div className='grid'>
				{barbers && barbers.length > 0 ? (
					barbers.map((barber, i) => (
						<div key={i} className={` card`}>
							<div className='card-body'>
								<div className='card-header'>
									<h3 className='capitalize-first'>{barber.name}</h3>
									<Link to={`/edit-staff/${barber.id}`} className="edit"><Icons.Edit /></Link>
									<span onClick={ () => handleDelete(barber.id)} className="delete"><Icons.trash /></span>
								</div>
								<p>{barber.mobile}</p>
								{barber.email ? (
									<p><span className="icon"><Icons.Email /></span>{barber.email}</p>
								) : ('')}
							</div>
						</div>
					))
				) : (
					<div className="empty-state">
						<img src={empty} alt="no_barber" />
						<p>No Staff added yet</p>
						<Link to="/add-shop-barber" className="btn-primary">Add Now</Link>
					</div>
				)}
			</div>
		</div>
	);
};

export default BarbersInShop;